import { useEffect } from 'react';
import { clockNow, useClock } from '@/state/store';
import { useLoader } from '../store';
import { usePass } from './store';
import { usePresentation } from '../ui/presentation';

/** Stays mounted with the loader runtime, including while inspecting the ground twin. */
export function usePassPlayback() {
  useEffect(() => {
    let previous = clockNow();
    const timer = setInterval(() => {
      const now = clockNow();
      const { selected, replaying } = usePass.getState();
      if (
        selected &&
        usePresentation.getState().eventFollowing &&
        window.location.pathname.startsWith('/loader')
      ) {
        if (previous < selected.startMs && now >= selected.startMs && now < selected.endMs) {
          useLoader.getState().setView({ sceneMode: '3D' });
          useLoader.getState().setTracked(selected.missionId);
        }
        if (previous < selected.endMs && now >= selected.endMs) useLoader.getState().setTracked(null);
      }
      if (selected && replaying && now >= selected.endMs + 30_000) {
        useClock.setState({ simTime: selected.endMs + 30_000, playing: false });
        usePass.setState({ replaying: false });
      }
      previous = now;
    }, 100);
    const stop = useLoader.subscribe((s, previousState) => {
      if (s.network !== previousState.network) usePass.getState().select(null);
    });
    return () => {
      clearInterval(timer);
      stop();
    };
  }, []);
}
